import React, { useContext, useEffect, useState } from "react";
import { createStyles } from "@mantine/emotion";
import AppLayout from "../../Components/Styles/AppLayout";
import ContentLayout from "../../Components/Styles/ContentLayout";
import Header from "../../Components/Common/Header";
import { useSelector } from "react-redux";
import axios from "axios";
import { AppContext } from "../../context";
import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";

let source;

const useStyles = createStyles(() => ({
  outerWrapper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "2rem 1rem",
  },
  link: {
    marginTop: "21.5px",
  },
}));

const Accessibility = () => {
  const { classes } = useStyles();
  const { config, language } = useSelector((state) => ({
    config: state.config,
    language: state.language,
  }));
  const { state } = useContext(AppContext);
  const { culture, posId } = state;
  const [text, setText] = useState("");

  const fetchFallback = async () => {
    axios
      .get(
        `${config.baseUrl}/ee-static/checkout/pos-${posId}/Texts/accessibility.sv-SE.md`,
        {
          cancelToken: source.token,
        }
      )
      .then((response) => {
        console.log(response);
        setText(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const fetchMarkdown = async (cul) => {
    axios
      .get(
        `${config.baseUrl}/ee-static/checkout/pos-${posId}/Texts/accessibility.${cul}.md`,
        {
          cancelToken: source.token,
        }
      )
      .then((response) => {
        setText(response.data);
      })
      .catch((error) => {
        console.log(
          "Couldn't find accessibility." + cul + ", falling back to sv-SE"
        );
        fetchFallback();
      });
  };

  useEffect(() => {
    if (config && language) {
      document.title = `${language.Accessibility} - ${config.shopName}`;
    }
  }, [config, language]);

  useEffect(() => {
    let CancelToken = axios.CancelToken;
    source = CancelToken.source();
    if (config && culture) {
      fetchMarkdown(culture);
    }
  }, [culture, config]);

  return (
    <AppLayout pageName="update-success">
      <Header hideUser={true} config={config} language={language} />
      <ContentLayout>
        <main className={classes.outerWrapper} id="main-page-content">
          <ReactMarkdown className="terms__text" rehypePlugins={[rehypeRaw]}>
            {text}
          </ReactMarkdown>
        </main>
      </ContentLayout>
    </AppLayout>
  );
};

export default Accessibility;
